import styled from '@emotion/styled'
import { Star } from 'app/components/Icons'
import { FlexBox } from 'app/components/Layout/FlexBox'
import { styles } from 'app/theme'
import React, { memo } from 'react'

import { Bottom } from './Bottom'
import { Brands } from './Brands'
import { Contacts } from './Contacts'
import { Props as FooterMenuItemProps } from './FooterMenuItem'
import { Menu } from './Menu'
import { Props as PolicyMenuItemProps } from './PolicyMenuItem'

export interface Props {
  address?: string
  cin?: string
  companyEmail?: string
  companyName?: string
  email?: string
  facebookURL?: string
  instagramURL?: string
  languageCode: string
  googleMapsURL?: string
  phone?: string
  footerMenu?: { [key: string]: FooterMenuItemProps[] }[]
  policyMenu?: { [key: string]: PolicyMenuItemProps[] }[]
  rea?: string
  registeredOffice?: string
  shareCapital?: string
  siteName?: string
  whatsapp?: string
  whatsappURL?: string
  vat?: string
}

export const Footer = memo(function Footer({
  address,
  cin,
  companyEmail,
  companyName,
  email,
  facebookURL,
  instagramURL,
  footerMenu,
  googleMapsURL,
  languageCode,
  phone,
  policyMenu,
  rea,
  registeredOffice,
  shareCapital,
  siteName,
  vat,
  whatsapp,
  whatsappURL,
}: Props) {
  return (
    <Container>
      <Logo>
        <Title>
          <div>Hotel Hiberia Roma</div>
          <div>
            <Star />
            <Star />
            <Star />
          </div>
        </Title>
      </Logo>
      <Contacts
        address={address}
        email={email}
        googleMapsURL={googleMapsURL}
        languageCode={languageCode}
        phone={phone}
        facebookURL={facebookURL}
        instagramURL={instagramURL}
        whatsapp={whatsapp}
        whatsappURL={whatsappURL}
      />
      <Menu languageCode={languageCode} footerMenu={footerMenu} />
      <Brands languageCode={languageCode} />

      <Bottom
        cin={cin}
        companyEmail={companyEmail}
        companyName={companyName}
        email={email}
        phone={phone}
        languageCode={languageCode}
        policyMenu={policyMenu}
        vat={vat}
        rea={rea}
        registeredOffice={registeredOffice}
        shareCapital={shareCapital}
      />
    </Container>
  )
})

const Container = styled.section`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 6rem;
  padding: 6rem 10vw 3.75rem;

  @media (max-width: 1199px) {
    margin-top: 3rem;
    padding: 3rem 1.5rem 6.875rem;
  }
`

const Title = styled.div`
  ${styles.title.large}

  color: ${({ theme }) => theme.colors.variants.primaryDark};
  text-transform: uppercase;
  max-width: 14.375rem;
  line-height: 2.625rem;

  svg {
    width: 0.375rem;
    height: 0.375rem;
    fill: ${({ theme }) => theme.colors.variants.primaryDark};

    &:not(:last-of-type) {
      margin-right: 0.5rem;
    }
  }

  @media (max-width: 1199px) {
    max-width: 17.5rem;
  }
`

const Logo = styled.div`
  position: relative;

  @media (max-width: 1199px) {
    width: 100%;
    margin-bottom: 3rem;
  }
`
